import React, { Component } from "react";  
   
class Comp1 extends Component {  
  constructor() {  
    super();  
    this.state = {  
      name: "ReactJS",
      aboutinfo: ''
    };  
  }  

   componentDidMount() {

      let info = this.props.paraminfo;

      info = info.replace("1.",'<br/>1.');
      info = info.replace("2.",'<br/>2.');
      info = info.replace("3.",'<br/>3.');
      info = info.replace("4.",'<br/>4.');
      info = info.replace("5.",'<br/>5.');
      info = info.replace("6.",'<br/>6.');
      info = info.replace("7.",'<br/>7.');
      info = info.replace("8.",'<br/>8.');

      this.setState({aboutinfo:info});
   }

   
  render() {  
    return <div id="about_section"><h3>About</h3>
            <div class="aboutinfo" dangerouslySetInnerHTML={{__html:this.state.aboutinfo}}></div>
          </div>
  }  
}  
   
export default Comp1;